import { useNavigate } from "react-router-dom";
import { VideoCallRoom } from "@/features/videocall/components/VideoCallRoom";

export default function VideoCallDemoPage() {
  const navigate = useNavigate();

  const handleEndCall = (callData?: any) => {
    navigate("/session-summary", { state: { callData } });
  };

  // Demo customer data
  const demoCustomerData = {
    name: "Demo Customer",
    phone: "555-DEMO",
    email: "demo@example.com",
    project: "Demo Project"
  };

  return (
    <VideoCallRoom
      roomId="demo-room"
      isHost={true}
      onEndCall={handleEndCall}
      customerData={demoCustomerData}
    />
  );
}